module.exports = __webpack_public_path__ + "img/logo@2x.6331598a.png";